import { render } from "./examPointView.vue?vue&type=template&id=317a85a0"
import script from "./examPointView.vue?vue&type=script&lang=js"
export * from "./examPointView.vue?vue&type=script&lang=js"

import "./examPointView.vue?vue&type=style&index=0&id=317a85a0&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__